import { Star } from "@phosphor-icons/react";

export default function StarRating({ value = 0, size = 14, showValue = false, count = 0, interactive = false, onChange }) {
  return (
    <div className="flex items-center gap-2" data-testid="star-rating">
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type={interactive ? "button" : undefined}
            disabled={!interactive}
            onClick={() => interactive && onChange?.(n)}
            className={interactive ? "cursor-pointer" : "cursor-default"}
            data-testid={interactive ? `star-${n}` : undefined}
          >
            <Star size={size} weight={n <= Math.round(value) ? "fill" : "regular"} color={n <= Math.round(value) ? "#4A1525" : "#D9C5B2"} />
          </button>
        ))}
      </div>
      {showValue && (
        <span className="text-xs text-[#5C5C5C]">
          {value > 0 ? value.toFixed(1) : "No reviews"} {count > 0 && `(${count})`}
        </span>
      )}
    </div>
  );
}
